import { render, staticRenderFns } from "./PaperWork.vue?vue&type=template&id=d2f12292&scoped=true"
import script from "./PaperWork.vue?vue&type=script&lang=js"
export * from "./PaperWork.vue?vue&type=script&lang=js"
import style0 from "./PaperWork.vue?vue&type=style&index=0&id=d2f12292&prod&lang=scss"
import style1 from "./PaperWork.vue?vue&type=style&index=1&id=d2f12292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f12292",
  null
  
)

export default component.exports